import React from 'react';
import shelegApi from '../api/shelegAPI';
import langConf from "../js/lang";

class CustomerDetails extends React.Component {

    validateEmail(email) {
        if (email === '')
            return false;
        if (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
            return true;
        }
        return false;
    };




    handleClick = async (event) => {
        event.preventDefault();
        const lang = this.props.language;
        const email = document.querySelector('#email').value;
        const customerName = document.querySelector('#customerName').value;
        if (customerName === ''){
            alert(langConf[lang].missingCustomerName);
            return false;
        }
        if (!this.validateEmail(email)){
            alert(langConf[lang].invalidEmail);
            return false;
        }
        let pkg = {
            mobile: this.props.mobile,
            email: email,
            name: customerName
        };
        //console.log(pkg);
        let response = await shelegApi.post(`/SaveWAEmailCust`, pkg);
        //console.log('response: ', response);
        if (response.statusText === 'Created') {
            pkg = {
                sessionId: this.props.sessionId,
                recipientNo: this.props.mobile,
                senderNo: '+16694000616',
                msgText: `${langConf[lang].waInstructions}`,
            };
            //console.log('pkg: ', pkg);
            response = await shelegApi.post('/SendWAMsg/', pkg);
            //console.log('response: ', response);
            if (response.statusText === "OK") {
                this.props.changeScreen('success');
            }
        }
    };

    render() {
        const lang = this.props.language;
        return (
            <div className='col-xl-12'>
                <div className="col-xl-4 col-lg-4 col-md-0 col-sm-0 col-0"></div>
                <div className='form-group col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12'>
                    <input type='text' placeholder={langConf[lang].customerName} id='customerName' className='form-control input-lg' />
                </div>
                <div className="col-xl-4 col-lg-4 col-md-0 col-sm-0 col-0"></div>
                <div className="col-xl-12">
                    <div className="col-xl-4 col-lg-4 col-md-0 col-sm-0 col-0"></div>
                    <div className='form-group col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12'>
                        <input type='email' placeholder={langConf[lang].email} id='email' className='form-control input-lg' />
                    </div>
                    <div className="col-xl-4 col-lg-4 col-md-0 col-sm-0 col-0"></div>
                </div>
                <div className="col-xl-12">
                    <div className="col-xl-4 col-lg-4 col-md-0 col-sm-0 col-0"></div>
                    <div className='form-group col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12'>
                        <input type='button' className='btn btn-success btn-lg btn-block' value={langConf[lang].send} onClick={this.handleClick} />
                    </div>
                    <div className="col-xl-4 col-lg-4 col-md-0 col-sm-0 col-0"></div>
                </div>
            </div>
        );
    }
}

export default CustomerDetails;